import { StoreState } from 'state/types';

const getState = (state: StoreState) => state.allowedToAssignShiftsResponse;
const getAllowedToAssignShifts = (state: StoreState) => getState(state).shifts;
export const getAllowedToAssignShiftsArray = (state: StoreState) =>
  Object.values(getAllowedToAssignShifts(state));
